<div>
    <img class="full-width" src="{{iconSrc}}" alt="{{iconAlt}}"/>
    <div class="text-center title">{{title}}</div>
</div>
